export default __webpack_public_path__ + "static/media/about-me.6f4feac6.jpg";